import { createSlice } from '@reduxjs/toolkit';

import { initSucceeded } from '../../actions/priceMatrixActions';

// Spreads over a null initial state, so the first success produces an object with just the link.
const combinationInfoSlice = createSlice({
  name: 'combinationInfo',
  initialState: null,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(initSucceeded, (state, action) => ({
      ...state,
      summaryReturnLink: action.payload.summaryReturnLink,
    }));
  },
});

export default combinationInfoSlice.reducer;
